import { getGameId } from '@/common/store'
import { OmniHeroesCommunity } from '@/types'
import request from './requets'

export type IconBean = {
    name: string
    img: string,
    key: string,
    id: number
}

type ArticleBean = {
    id: number,
    content: string,
    title: string,
    publish_datetime: string,
    heat_value: number,
    tags?: Array<{ tag_name: string, tag_id: string | number, colour: string }>,
    thumbnail: string,
    classification_name: string,
    classification: string | number,
    publisher_portrait: string,
    publisher_name: string,
    share_cnt: string | number,
    view_cnt: string | number,
    like_cnt: string | number,
    unlike_cnt: string | number,
    time_like: number,
    time_unlike: number,
    is_top: number,
    is_suggest: number
}

class NewsModel {

    getLanguage() {
        const l = sessionStorage.getItem('language') || 'en'
        // 如果是香港 台湾 传递语言为中文繁体
        if (l == 'hk' || l == 'tw') {
            return 'hk_tw'
        }else if (l == 'zh' || l == 'ch') {
            return 'zh_ch'
        }
        return l
    }

    getCategoryList(includeAll?: boolean): Promise<Array<IconBean>> {
        return request({
            url: '/category',
            method: 'get',
            params: {
                game_id: getGameId(),
                language: this.getLanguage()
            }
        }).then(({ data: res }) => {
            const r = (res.data || []).map((mapItem: { id: number, name: string, icon_url: string, key: string }) => {
                return {
                    name: mapItem.name,
                    id: mapItem.id,
                    key: mapItem.key,
                    img: mapItem.icon_url
                }
            })
            if (includeAll) {
                return [
                    {
                        name: 'recommend',
                        img: '',
                        id: 0
                    },
                    ...r
                ]
            }
            return r
        })
    }

    getHotNews(parmas: Object): Promise<{ data: Array<OmniHeroesCommunity.NewBean>, total: number }> {
        return this.getArticleList({
            is_hot: 1,
            ...parmas
        })
    }

    getArticleList(parmas: any) {
        if (!parmas.classification) {
            parmas.tab = 'recommend'
        }
        return request({
            url: '/articles',
            method: 'get',
            params: {
                game_id: getGameId(),
                language: this.getLanguage(),
                ...parmas,
            }
        }).then(({ data: res }) => {
            return {
                data: (res.data || []).map((mapItem: ArticleBean) => {
                    return {
                        id: mapItem.id,
                        title: mapItem.title,
                        redu: mapItem.heat_value,
                        thumbnail: mapItem.thumbnail || '',
                        // todo 如果是推荐 按推荐置顶(is_suggest) 如果是分类（UGC 攻略） 按分类置顶(is_top) 2022-10-26 见证人老林
                        isRecommend: (parmas.tab == 'recommend' && mapItem.is_suggest) ||  (parmas.tab != 'recommend' && mapItem.is_top),
                        tags: [mapItem.classification_name]
                    }
                }),
                total: res.total || 0
            }
        })
    }

    getBannerList(): Promise<{ id: number, img: string }> {
        return request({
            url: '/carousel',
            method: 'get',
            params: {
                game_id: getGameId(),
                language: this.getLanguage()
            }
        }).then(({ data: res }) => {
            return (res.data || []).map((mapItem: { id: number, img_url: string, title: string, redirect_url: string }) => {
                return {
                    id: mapItem.id,
                    img: mapItem.img_url,
                    title: mapItem.title,
                    redirect_url: mapItem.redirect_url
                }
            })
        })
    }


    getTagList(classification_id?: string | number): Promise<Array<OmniHeroesCommunity.TagBean>> {
        return request({
            url: '/tags',
            method: 'get',
            params: {
                game_id: getGameId(),
                group_id: classification_id,
                language: this.getLanguage()
            }
        }).then(({ data: res }) => {
            return (res.data || []).map((mapItem: { name: string, id: number }) => {
                return mapItem
            })
        })
    }

    getTopicInfo(id: string | number): Promise<OmniHeroesCommunity.TopicBean> {
        return request({
            url: '/article',
            method: 'get',
            params: {
                game_id: getGameId(),
                id,
                uid: sessionStorage.getItem('uid') || null
            }
        }).then(({ data: res }) => {
          const mapItem = res.data || {}
          return {
                title: mapItem.title,
                tagList: (mapItem.tags || []).map((tagItem : any) => tagItem.tag_name),
                time: mapItem.publish_datetime,
                html: mapItem.content,
                autor: mapItem.publisher_name,
                rd: mapItem.heat_value,
                like: mapItem.like_cnt,
                unlike: mapItem.unlike_cnt,
                share: mapItem.share_cnt,
                photo: mapItem.publisher_portrait,
                time_unlike: mapItem.time_unlike,
                time_like: mapItem.time_like,
                time_share: mapItem.time_share,
                id: mapItem.id,
                thumbnail: mapItem.thumbnail,
                deleted: mapItem.deleted_at
            }
        })
    }

    like(id?: string | number) {
        return request({
            url: '/like',
            method: 'put',
            data: {
                game_id: getGameId(),
                uid: sessionStorage.getItem('uid') || null,
                id
            }
        })
    }

    share(id?: string | number) {
        return request({
            url: '/share',
            method: 'put',
            data: {
                game_id: getGameId(),
                uid: sessionStorage.getItem('uid') || null,
                id
            }
        })
    }

    cancelLike(id?: string | number) {
        return request({
            url: '/cancelLike',
            method: 'put',
            data: {
                game_id: getGameId(),
                uid: sessionStorage.getItem('uid') || null,
                id
            }
        })
    }



    unlike(id?: string | number) {
        return request({
            url: '/unlike',
            method: 'put',
            data: {
                game_id: getGameId(),
                uid: sessionStorage.getItem('uid') || null,
                id
            }
        })
    }

    cancelUnlike(id?: string | number) {
        return request({
            url: '/cancelUnlike',
            method: 'put',
            data: {
                game_id: getGameId(),
                uid: sessionStorage.getItem('uid') || null,
                id
            }
        })
    }

}
export default new NewsModel()